import { createSlice } from '@reduxjs/toolkit';
import { initialRolesState } from 'reducers/initialStates';

const rolesSlice = createSlice({
	name: 'roles',
	initialState: {
		//Set by configureStore
	},
	reducers: {
		setRolesPermAssignedList(state, action) {
			state.rolesPermAssignedList = action.payload;
		},
		resetRolesSlice() {
			return initialRolesState;
		}
	}
});

export const { setRolesPermAssignedList, resetRolesSlice } = rolesSlice.actions;

export default rolesSlice.reducer;

export const rolesPermAssignedListSelector = state => state.roles.rolesPermAssignedList;
